export enum KorrespondenzVorlageMessages {
	ASK_TO_DELETE_KORRESPONDENZ_VORLAGE = 'Die Korrespondenzvorlage wird gelöscht und kann nicht wieder hergestellt werden.<br/>Sind sie sicher?',
}
